import React from 'react';
import InAppWidget, { InAppWidgetProps } from '~/components/InAppWidget';

const InAppSlideIn = ({ onClose, url, language }: Omit<InAppWidgetProps, 'width' | 'height'>) => (
	<InAppWidget onClose={onClose} url={url} language={language} width={312} height={460} />
);

export default InAppSlideIn;
